import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/** Returns every placeholder detected in the source document, so the counts stay derived rather than typed. */
export async function parseAmTpDemoTemplate(
  context: TAmDemoAiContextFor<'templates.parse'>
) {
  return invokeAmTpDemoAiTask('templates.parse', context);
}
